import apiService from './api';
export class AuthService {
    // Login
    async login(credentials) {
        const response = await apiService.post('/auth/login', credentials);
        if (response.data) {
            this.setAuthData(response.data.token, response.data.user);
        }
        return response.data;
    }
    // Registro
    async register(userData) {
        const response = await apiService.post('/auth/register', userData);
        if (response.data) {
            this.setAuthData(response.data.token, response.data.user);
        }
        return response.data;
    }
    // Obter dados do usuário atual
    async getCurrentUser() {
        const response = await apiService.get('/auth/me');
        return response.data;
    }
    // Atualizar perfil
    async updateProfile(userData) {
        const response = await apiService.put('/auth/profile', userData);
        if (response.data) {
            this.updateStoredUser(response.data);
        }
        return response.data;
    }
    // Alterar senha
    async changePassword(passwords) {
        await apiService.put('/auth/change-password', passwords);
    }
    // Logout
    async logout() {
        try {
            await apiService.post('/auth/logout');
        }
        finally {
            this.clearAuthData();
        }
    }
    // Verificar se está autenticado
    isAuthenticated() {
        const token = this.getToken();
        if (!token)
            return false;
        try {
            const payload = JSON.parse(atob(token.split('.')[1]));
            const now = Date.now() / 1000;
            return payload.exp > now;
        }
        catch {
            return false;
        }
    }
    // Obter token
    getToken() {
        return localStorage.getItem('token');
    }
    // Obter usuário armazenado
    getStoredUser() {
        const userStr = localStorage.getItem('user');
        if (!userStr)
            return null;
        try {
            return JSON.parse(userStr);
        }
        catch {
            return null;
        }
    }
    // Definir dados de autenticação
    setAuthData(token, user) {
        localStorage.setItem('token', token);
        localStorage.setItem('user', JSON.stringify(user));
    }
    // Atualizar usuário armazenado
    updateStoredUser(user) {
        localStorage.setItem('user', JSON.stringify(user));
    }
    // Limpar dados de autenticação
    clearAuthData() {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
    }
    // Verificar permissões
    hasPermission(requiredRoles) {
        const user = this.getStoredUser();
        if (!user)
            return false;
        // SUPER_ADMIN tem acesso a tudo
        if (user.tipo === 'SUPER_ADMIN')
            return true;
        return requiredRoles.includes(user.tipo);
    }
    // Verificar se é admin
    isAdmin() {
        return this.hasPermission(['ADMIN']);
    }
    // Verificar se é técnico
    isTecnico() {
        return this.hasPermission(['TECNICO']);
    }
    // Verificar se é vendedor
    isVendedor() {
        return this.hasPermission(['VENDEDOR']);
    }
    // Validar força da senha
    validatePasswordStrength(password) {
        const errors = [];
        let score = 0;
        if (password.length < 8) {
            errors.push('A senha deve ter pelo menos 8 caracteres');
        }
        else {
            score += 1;
        }
        if (!/[a-z]/.test(password)) {
            errors.push('A senha deve conter pelo menos uma letra minúscula');
        }
        else {
            score += 1;
        }
        if (!/[A-Z]/.test(password)) {
            errors.push('A senha deve conter pelo menos uma letra maiúscula');
        }
        else {
            score += 1;
        }
        if (!/\d/.test(password)) {
            errors.push('A senha deve conter pelo menos um número');
        }
        else {
            score += 1;
        }
        if (!/[!@#$%^&*()_+\-=\[\]{}|;:,.<>?]/.test(password)) {
            errors.push('A senha deve conter pelo menos um símbolo especial');
        }
        else {
            score += 1;
        }
        return {
            isValid: errors.length === 0,
            errors,
            score
        };
    }
    // Gerar senha aleatória
    generateRandomPassword(length = 12) {
        const lowercase = 'abcdefghijklmnopqrstuvwxyz';
        const uppercase = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
        const numbers = '0123456789';
        const symbols = '!@#$%^&*()_+-=[]{}|;:,.<>?';
        const all = lowercase + uppercase + numbers + symbols;
        let password = '';
        // Garantir pelo menos um de cada tipo
        password += lowercase[Math.floor(Math.random() * lowercase.length)];
        password += uppercase[Math.floor(Math.random() * uppercase.length)];
        password += numbers[Math.floor(Math.random() * numbers.length)];
        password += symbols[Math.floor(Math.random() * symbols.length)];
        // Preencher o resto
        for (let i = 4; i < length; i++) {
            password += all[Math.floor(Math.random() * all.length)];
        }
        // Embaralhar
        return password.split('').sort(() => Math.random() - 0.5).join('');
    }
}
// Instância singleton
const authService = new AuthService();
export default authService;
